import { toast } from 'react-toastify';
import { getAllUsers, editUserDetailsV2 } from '../../../store/investor/apiHelpers';
import { JAVA_API_STATUS } from '../../../utils/axios-interceptor';
import { TEAM_USERS_PAGE_SIZE, ROLE_ASSIGN_RETRY_MS, ROLE_ASSIGN_FAILED_MSG } from './ManageUserConstants';

const findCreatedUser = async (investorOrgId: string, emailLower: string) => {
    const fetchMatch = async () => {
        let pageNumber = 0;
        // Page through team users until the new user is found or the last (short) page is reached.
        // getAllUsers has no server-side email filter, so client-side paging is the only option.
        // eslint-disable-next-line no-constant-condition
        while (true) {
            const usersData = await getAllUsers({
                pageSize: TEAM_USERS_PAGE_SIZE,
                pageNumber,
                orgId: investorOrgId,
                userType: ['ADMIN_TEAM', 'INVESTOR'],
            });
            const users = usersData?.userDetails ?? [];
            const match = users.find((u: any) => u?.emailId?.toLowerCase() === emailLower);
            if (match || users.length < TEAM_USERS_PAGE_SIZE) return match;
            pageNumber += 1;
        }
    };

    const matched = await fetchMatch();
    if (matched?.userId) return matched;

    await new Promise((resolve) => setTimeout(resolve, ROLE_ASSIGN_RETRY_MS));
    return fetchMatch();
};

export const useAssignRoleAfterCreate = () => {
    const assignRoleAfterCreate = async (emailId: string, roleId: string, investorOrgId: string): Promise<void> => {
        try {
            const matched = await findCreatedUser(investorOrgId, emailId.toLowerCase());
            if (!matched?.userId) {
                toast.warn(ROLE_ASSIGN_FAILED_MSG);
                return;
            }
            const editResult = await editUserDetailsV2({
                userDetails: { userId: matched.userId, role: roleId },
                triggerNotification: false,
            });
            if (editResult?.responseData?.responseCode !== JAVA_API_STATUS.SUCCESS) {
                toast.warn(ROLE_ASSIGN_FAILED_MSG);
            }
        } catch (err) {
            console.error('Post-create role assignment failed:', err);
            toast.warn(ROLE_ASSIGN_FAILED_MSG);
        }
    };

    return { assignRoleAfterCreate };
};
